import { axiosInstance } from "../axios/axios"
import { createSmallBusiness } from "./customer-creation-service"

export const redirectToPayment = async (data: any) => {
    try {
        const customer = await createSmallBusiness(data)
        if (customer.status === 'success') {
            const payload = {
                price_id: !data.is_free_trial ? data.plan.split('-')[1] : null,
                customer_id: customer.customer,
                quantity: data.license,
                is_free_trial: !data.is_free_trial ? 'no' : 'yes'
            }
            const result = await axiosInstance.post('/generate-payment-url', payload)
            console.log(result)
            if (result.data.status === 'failed') {
                // setError(result.data.message)
                return { status: false, message: result.data.message }
            }
            else {
                window.location.href = result?.data?.payment_url
            }
        }
        else {
            // setError(customer.message)
            return { status: false, message: customer.message }

        }
    } catch (error) {
        console.log(error)
    }
}